import { Button, Checkbox, FormControlLabel, FormGroup, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'
import Cookies from 'universal-cookie'
import ReactGA from 'react-ga4'
import { CheckboxUnticked } from '../../utility/SVGUtility'
import { submitRequestForDemo } from '../../services/MarketplaceService'
import { SUCCESS } from '../../constants/Constants'
import ContactSuccess from './ContactSuccess'
import Waves from '../../assets/waves.svg'
import { CommonColorCodes } from '../../utility/CommonColorCodes'

interface HiddenProps {
  hide: boolean;
}

const ContactForm = styled.div<HiddenProps>`
  background: ${(props) => props.hide ? 'white' : ''};
  display: flex;
  flex-direction: column;
  padding: 60px 60px 40px 60px;
  border-radius: 8px;
  position: ${(props) => props.hide ? '' : 'absolute'};
  width: ${(props) => props.hide ? '' : '430px'};

  @media (min-width: 0px) and (max-width: 600px) {
    position: inherit;
    padding: 11px 0px 50px 26px;
    width: 84%;
  }
  @media (min-width: 601px) and (max-width: 900px) {
    position: inherit;
  }
`

const Heading = styled.div`
  font-family: 'AeonikPro-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  color: #35324A;
  @media (min-width: 0px) and (max-width: 360px) {
    font-size: 18.2359px;
    line-height: 27px;
  }
`

const FormField = styled(TextField)`
  margin-top: 15px;
  & > label {
      font-family: 'AeonikPro-Regular';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: ${CommonColorCodes.INK_300};
  }
  & > div > input {
      font-family: 'AeonikPro-Regular';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
  }
  @media (min-width: 0px) and (max-width: 400px) {
    margin-top: 10px;
      & > label {
    font-size: 12.1573px;
          line-height: 18px;
      }
      & > div > input {
    font-size: 12.1573px;
          line-height: 18px;
      }
  }
`

const Purpose = styled.div`
  margin-top: 10px;
  display: flex;
  font-family: 'AeonikPro-Regular';
  & > span {
    margin-top: 10px;
    font-style: normal;
    font-size: 16px;
    font-wight: 400;
    line-height: 24px;
    color: ${CommonColorCodes.INK_300};
  }
  & > div {
    margin-left: auto;
    margin-right: -15px;
  }

  @media (min-width: 0px) and (max-width: 360px) {
    height: 40px;
    margin-top: 10px;
    & > span {
        margin: auto 0;
        font-size: 12.1573px;
        line-height: 18px;
    }
  }
`

const Disclaimer = styled.div`
    height: 16px;
    font-family: inherit;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: ${CommonColorCodes.INK_300};
    @media (min-width: 0px) and (max-width: 360px) {
      font-size: 12px;
      line-height: 18px;
    }
`

const TypographyWrapper = styled(Typography)`
    color: #35324A;
    font-family: 'AeonikPro-Regular';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    @media (min-width: 0px) and (max-width: 360px) {
            font-size: 12.1573px;
            line-height: 18px;
    }
`

const RequestDemoStyles = {
  borderRadius: '4px',
  width: '100%',
  margin: '20px auto 20px auto',
  backgroundColor: '#FF6B18',
  textTransform: 'none',
  fontFamily: 'AeonikPro-Regular',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '16px'
}

const WavesImg = styled.img.attrs(() => ({
  src: Waves
}))`
  display: block;
  margin: auto;
  @media (min-width: 601px) and (max-width: 900px) {
    margin-left: 0%;
  }
`

const WavesDiv = styled.div`
position: absolute;
width: 550px;
height: 101px;
left: 0px;
top: -4px;
@media (min-width: 0px) and (max-width: 600px) {
  width: 100%;
  overflow: hidden;
}

`

const InitialState = {
  name: '',
  request: '',
  email: '',
  number: '',
  company: '',
  office: false,
  personal: false
}

interface IProps{
  appId: string | undefined;
  open: boolean
  handleClose : ()=> void
  appName: string | undefined;
}

const Contact = (props: IProps) => {
  const { appId } = props.appId ? props : useParams()
  const [formData, setFormData] = useState(InitialState)
  const [helpertext, setHelperText] = useState(InitialState)
  const [openSuccess, setOpenSuccess] = useState(false)
  const { appName } = props.appName ? props : useParams()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [event.target.name]: event.target.checked })
  }

  const updateValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [event.target.id]: event.target.value })
  }

  const contactRequestCallback = (response:object, status:string) => {
    if (status === SUCCESS) {
      if (appId) {
        const cookies = new Cookies()
        cookies.set(appId, true, { path: '/' })
      }
      !appId && props.handleClose()
      setOpenSuccess(true)
    } else {
      console.error('Error in receiving response')
    }
  }

  const handleSubmit = () => {
    const isValid = validate()
    if (appId && isValid) {
      const contactRequest = {
        appId,
        name: formData.name,
        email: formData.email,
        number: formData.number,
        company: formData.company,
        purpose: formData.office ? 'Official' : 'Personal'
      }
      submitRequestForDemo(contactRequestCallback, contactRequest)
      ReactGA.event({
        category: 'Request Demo',
        action: 'Request Demo',
        label: appName
      })
    }
  }

  useEffect(() => {
    Object.keys(InitialState).map(field => {
      const element = document.getElementById(field + '-helper-text')
      if (element) {
        element.style.color = 'red'
      }
      return element
    })
  })

  const validate = () => {
    let isValid = true
    const errtext = { ...InitialState }
    if (formData.name.trim().length === 0) {
      errtext.name = "Name can't be empty"
      isValid = false
    } else if (!formData.name.match(/^[a-zA-Z ]+$/)) {
      errtext.name = 'Invalid Name'
      isValid = false
    } else {
      errtext.name = ''
    }
    if (!appId && formData.request.trim().length === 0) {
      errtext.request = "Request cann't be empty"
      isValid = false
    } else {
      errtext.request = ''
    }
    if (!formData.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      errtext.email = 'Invalid email'
      isValid = false
    } else {
      errtext.email = ''
    }

    if (!formData.number.match(/^(?=.*[0-9])[- +()0-9]+$/)) {
      errtext.number = 'Invalid contact number'
      isValid = false
    } else {
      errtext.number = ''
    }
    setHelperText({ ...errtext })

    return isValid
  }

  const handleContact = () => {
    props.handleClose()
    const isValid = validate()
    const contactRequest = {
      name: formData.name,
      email: formData.email,
      number: formData.number,
      company: formData.company,
      request: formData.request
    }
    isValid && submitRequestForDemo(contactRequestCallback, contactRequest)
    ReactGA.event({
      category: 'Contact Us',
      action: 'Contact Us'
    })
  }

  return (
    <>
    {appId && <WavesDiv>
      <WavesImg />
    </WavesDiv>}
    {!openSuccess && <ContactForm hide ={!appId}>

          {appId && <Heading style={{ marginTop: '100px' }}>Send request</Heading>}
          {!appId && <Heading> How can we reach you? </Heading>}
          {<FormField id="name" helperText={helpertext.name} label="Name*" variant="standard" value={formData.name} onChange={updateValue} />}

          <FormField id="email" label="Email*" helperText={helpertext.email} variant="standard" value={formData.email} onChange={updateValue} />
          <FormField id="number" label="Phone*" helperText={helpertext.number}variant="standard" value={formData.number} onChange={updateValue} />
          <FormField id="company" label="Company" helperText={helpertext.company} variant="standard" value={formData.company} onChange={updateValue} />

          {!appId && <label style={{ color: '#9d95a2', marginTop: '24px', marginBottom: '8px' }}> Message*</label>}
          {!appId && <TextField id="request" multiline helperText={helpertext.request} rows={2} maxRows={4} label="" variant="outlined" value={formData.request} onChange={updateValue}/>}

          {false && <Purpose>
            <span>Purpose:</span>
            <FormGroup row>
              <FormControlLabel control={<Checkbox icon={<CheckboxUnticked/>} checked={formData.office} onChange={handleChange} name='office' />} label={<TypographyWrapper >Office</TypographyWrapper>} />
              <FormControlLabel control={<Checkbox icon={<CheckboxUnticked/>} checked={formData.personal} onChange={handleChange} name='personal' />} label={<TypographyWrapper >Personal</TypographyWrapper>} />
            </FormGroup>
          </Purpose>}
          {appId && <Button variant='contained' size='large' color='info' onClick={handleSubmit} sx={[RequestDemoStyles,
            () => ({
              '&:hover': { backgroundColor: '#FF6B18' },
              '@media (min-width: 0px) and (max-width: 360px)': { fontSize: '15px', marginTop: '10px', marginBottom: '0px' }
            })
          ]}> Request Demo </Button>}
            {!appId && <Button variant='contained' size='large' color='info' onClick={handleContact} sx={[RequestDemoStyles,
              () => ({
                backgroundColor: '#FF6B18',
                '&:hover': { backgroundColor: '#FF6B18' },
                '@media (min-width: 0px) and (max-width: 360px)': { fontSize: '15px', marginTop: '10px', marginBottom: '0px' }
              })
            ]} > Submit </Button>}

          <Disclaimer>
            <p>By submitting you agree to our <a target='_blank' style ={{ textDecoration: 'none', color: `${CommonColorCodes.INK_300}` }} href='https://whatfix.com/terms-of-service/' rel="noreferrer">
            <b>Terms of Service </b>
            </a> &
            <a target='_blank' style ={{ textDecoration: 'none', color: `${CommonColorCodes.INK_300}` }} href='https://whatfix.com/privacy-policy/' rel="noreferrer">
            <b> Privacy Policy</b>
            </a></p>
          </Disclaimer>
        </ContactForm>}
        <div>

        {openSuccess && <ContactSuccess isDemo = {!!appId} /> }
    </div>
    </>
  )
}

export default Contact
